import styled from "styled-components";

export const PageWrapper = styled.div<{ embedded?: boolean }>`
  max-width: ${({ embedded }) => (embedded ? "none" : "900px")};
  margin: ${({ embedded }) => (embedded ? "0" : "20px")};
  font-family: ${({ theme }) => theme.regularTextTypeface};
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.textColor};
  font-weight: 700;
  margin-bottom: 20px;
`;

export const Card = styled.div<{ embedded?: boolean }>`
  background: #ffffff;
  border-radius: 16px;
  padding: ${({ embedded }) => (embedded ? "0" : "28px")};
  box-shadow: ${({ embedded }) => (embedded ? "none" : "0 10px 30px rgba(46, 56, 98, 0.08)")};
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.greyBackground};
  border: 1px solid #e3e8f5;
  border-radius: 10px;
  padding: 12px 16px;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 0 24px 0 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    color: ${({ theme }) => theme.textColor};
    cursor: pointer;

    &::placeholder {
      color: ${({ theme }) => theme.textColor};
      opacity: 1;
    }
  }

  .react-datepicker__close-icon {
    right: 20px;
    padding: 0;
  }
`;

export const FieldLabel = styled.label`
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #9aa1b5;
`;

export const CalendarIcon = styled.span`
  position: absolute;
  right: 16px;
  bottom: 14px;
  color: #9aa1b5;
  font-size: 15px;
  pointer-events: none;
`;

export const SectionLabel = styled.label`
  display: block;
  margin: 24px 0 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #9aa1b5;
`;

export const OccupancyGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  & + & {
    margin-top: 16px;
  }

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const OccupancyItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OccupancyItemLabel = styled.span`
  margin-bottom: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.textColor};
`;

export const Stepper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.greyBackground};
  border: 1px solid #e3e8f5;
  border-radius: 10px;
  padding: 6px 12px;
`;

export const StepperButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.regularTextColor};
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: rgba(46, 56, 98, 0.06);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const StepperValue = styled.span`
  min-width: 24px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  > *:last-child {
    flex: 2 1 0;
  }

  > *:not(:last-child) {
    flex: 1 1 0;
  }
`;
